import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { getUserInfo } from './api'

Vue.use(ElementUI)
Vue.config.productionTip = false
const create = () => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
}
const checkLogin = () => {
    if (localStorage.getItem('uq_token')) {
        var params = { token: localStorage.getItem('uq_token') }
        getUserInfo(params).then(res => {
            if (!res.data) {
                localStorage.removeItem('uq_token')
                create()
            } else {
                store.commit('username', res.data.username)
                store.commit('userlv', res.data.userlv)
                create()
            }
        })
    } else {
        create()
    }
}

checkLogin()
